<template>
  <form ref="form" @submit.prevent="handleSubmit">
    <label>{{ label }}{{ required ? '*' : null }}</label>
    <v-text-field
      v-model="dateFormated"
      ref="input"
      color="accent"
      :name="name"
      :placeholder="placeholder"
      :mask="mask"
      return-masked-value
      append-icon="today"
      v-validate="{
        required,
        date_format: format === 'YYYY-MM' ? 'MM/yyyy' : 'dd/MM/yyyy'
      }"
      :error-messages="errors.collect(name)"
      :data-vv-name="name"
      required
      flat
      outline
      solo
      @click:append="openDialog"
      @click="openOnClick && openDialog()"
      @blur="emitValue"
    />

    <v-dialog
      v-model="dialog"
      :open-on-click="false"
      :close-on-content-click="false"
      lazy
      full-width
      width="290"
    >
      <v-date-picker
        v-model="date"
        :locale="currentLocale"
        :min="min"
        color="accent"
        :type="format === 'YYYY-MM' ? 'month' : 'date'"
        @change="closeDialog"
      />
    </v-dialog>
  </form>
</template>

<script>
// import moment from 'moment'
export default {
  name: 'DatePickerInput',
  props: {
    label: {
      type: String,
      required: true
    },
    placeholder: {
      type: String,
      required: true
    },
    name: {
      type: String,
      required: true
    },
    required: {
      type: Boolean,
      required: false
    },
    format: {
      type: String,
      default: 'YYYY-MM-DD'
    },
    submit: {
      type: Boolean
    },
    min: {
      type: String
    },
    resetField: {
      type: Boolean
    },
    openOnClick: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    mask () {
      return this.format === 'YYYY-MM' ? '##/####' : '##/##/####'
    },

    currentLocale () {
      return this.$i18n.locale.split('_').join('-')
    }
  },
  data () {
    return {
      date: null,
      dateFormated: null,
      dialog: false
    }
  },
  methods: {
    emitValue () {
      this.$emit('change', this.dateFormated)
    },

    openDialog () {
      this.dialog = true
    },

    resetFields () {
      this.date = null
      this.dateFormated = null
      this.dialog = false
    },

    closeDialog () {
      this.dialog = false

      if (this.date && this.format === 'YYYY-MM') {
        const date = this.date
        const [y, m] = date.split('-')
        const newDate = [].concat(y, m).reverse().join('/')
        this.dateFormated = newDate
      }

      if (this.date && this.format === 'YYYY-MM-DD') {
        this.dateFormated = this.date.split('-').reverse().join('/')
      }

      this.$refs.input.focus()
      setTimeout(() => this.$refs.input.blur(), 200)

      this.emitValue()
    },

    async handleSubmit () {
      const isValid = await this.$validator.validateAll()
      this.emitValue()

      if (isValid) {}
    }
  },
  watch: {
    submit () {
      this.handleSubmit()
    },

    resetField () {
      this.resetFields()
    }
  }
}
</script>
